import {
  Condition as ModelCondition,
  SkuOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface SkuState {
  codes: readonly string[];
  skuOption: SkuOption | null;
}

export const SKU = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SkuState>>,
): ConditionType<SkuState, ModelCondition.Sku> => ({
  name: "SKU",
  description(state) {
    switch (state.skuOption!) {
      case SkuOption.EQUALS:
        return "SKU matches one from list";
      case SkuOption.STARTS_WITH:
        return "SKU starts with one from list";
      case SkuOption.ENDS_WITH:
        return "SKU ends with one from list";
      case SkuOption.INCLUDES:
        return "SKU includes one from list";
    }
  },
  Details(props: ConditionTypeDetailsProps<SkuState>) {
    return React.createElement(Details, props);
  },
  empty: { codes: [], skuOption: SkuOption.EQUALS },
  fromModel(model: ModelCondition.Sku) {
    return { codes: model.codes, skuOption: model.skuOption || null };
  },
  toModel(state) {
    return {
      type: ModelCondition.SKU,
      codes: state.codes,
      skuOption: state.skuOption || null,
    };
  },
  valid() {
    return true;
  },
});
